import React from 'react'
import banner from '../../assests/images/banners/productlist.jpg'
import bootsbanner from '../../assests/images/banners/boot.jpg'
import coverallbanner from '../../assests/images/banners/coverall.jpg'
import eyewearbanner from '../../assests/images/banners/eyewear.jpg'
import glovebanner from '../../assests/images/banners/glove.jpg'
import hatbanner from '../../assests/images/banners/hat.jpg'
import maskbanner from '../../assests/images/banners/mask.png'
import roadbanner from '../../assests/images/banners/road.jpg'
import contactusbanner from '../../assests/contact-us.jpg'

const Banner = ({id}) => {
  let bannerSrc, bannerAlt;
  switch (id) {
    case 'boots':
        bannerSrc = bootsbanner;
        bannerAlt = 'Boots banner';
        break;
    case 'coverall':
        bannerSrc = coverallbanner;
        bannerAlt = 'Coverall banner';
        break;
    case 'eyewear':
        bannerSrc = eyewearbanner;
        bannerAlt = 'Eyewear banner';
        break;
    case 'gloves':
        bannerSrc = glovebanner;
        bannerAlt = 'Gloves banner';
        break;
    case 'hats':
        bannerSrc = hatbanner;
        bannerAlt = 'Hats banner';
        break;
    case 'masks':
        bannerSrc = maskbanner;
        bannerAlt = 'Mask banner';
        break;
    case 'roadsafety':
        bannerSrc = roadbanner;
        bannerAlt = 'Road banner';
        break;
    case 'contact':
        bannerSrc = contactusbanner;
        bannerAlt = 'Road banner';
        break;
    default:
        bannerSrc = banner;
        bannerAlt = 'Safety Products banner';
        break;
}
  return (
    <img className='banner' src={bannerSrc} alt={bannerAlt} />
  )
}

export default Banner